var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup437(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.5px",
    d: "M28.035 22.609v11.355l-2.942 2.942v-14.3L17.779 15.3h17.613l-7.357 7.313",
    transform: "translate(.196) translate(.75 3.711)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: "2.5px",
    d: "M0 0h19.525",
    transform: "translate(.196) translate(17.573 15.168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H55V55H0z",
    transform: "translate(.196) translate(-.196)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup437);
export default __webpack_public_path__ + "static/media/Group 437.3bfe467ba947deabd400cffe830de6e9.svg";
export { ForwardRef as ReactComponent };